import styled from "styled-components";
import { Container } from "../../styles/Container";

export const Wrapper = styled.div`
  margin: 4rem auto;

  ${Container}
`;

export const Content = styled.div`
  width: 100%;
  padding: 1rem 0;

  h1 {
    text-align: center;
    font-size: 4rem;
  }
  section {
    padding: auto 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;

    @media (max-width: 992px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

export const Pic = styled.img`
  width: 100%;
  float: left;
`;

export const AbtMe = styled.div`
  padding: 0 auto;
  h1 {
    font-size: 3rem;
    margin: 0;
    text-align: left;
  }
  p {
    font-weight: 300;
    line-height: 2rem;
  }
  .justified{
    text-align: justify;
  }
`;
